import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "member", "empty", "summary", "selected"]

  connect() {
    this.filter()
    this.renderSelected()
  }

  filter() {
    const query = this.queryTarget.value.trim().toLocaleLowerCase()
    let visibleCount = 0
    let matchCount = 0

    this.memberTargets.forEach((member) => {
      const matches = member.dataset.search.includes(query)
      if (matches) matchCount += 1

      const selected = member.dataset.selected === "true"
      const withinInitialLimit = query.length > 0 || selected || visibleCount < 20
      const visible = matches && withinInitialLimit
      member.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    this.emptyTarget.classList.toggle("hidden", matchCount > 0)
    this.summaryTarget.textContent = query.length > 0
      ? `${matchCount} result${matchCount === 1 ? "" : "s"}`
      : `Showing ${visibleCount} of ${this.memberTargets.length} · search by name or email`
  }

  selectionChanged(event) {
    const member = event.currentTarget.closest('[data-team-filter-target="member"]')
    if (member) member.dataset.selected = event.currentTarget.checked.toString()

    this.queryTarget.value = ""
    this.filter()
    this.renderSelected()
    this.queryTarget.focus()
  }

  removeSelection(event) {
    const userId = event.currentTarget.dataset.userId
    const member = this.memberTargets.find((item) => item.dataset.userId === userId)
    const checkbox = member?.querySelector('input[type="checkbox"]')
    if (!member || !checkbox) return

    checkbox.checked = false
    member.dataset.selected = "false"
    this.filter()
    this.renderSelected()
  }

  renderSelected() {
    this.selectedTarget.replaceChildren()

    this.memberTargets.filter((member) => member.dataset.selected === "true").forEach((member) => {
      const chip = document.createElement("span")
      chip.className = "inline-flex items-center gap-1.5 rounded-full border border-purple-200 bg-purple-50 py-0.5 pl-1 pr-1.5 text-[10px] font-medium text-purple-700 dark:border-purple-500/20 dark:bg-purple-500/10 dark:text-purple-300"

      const avatar = member.dataset.avatarUrl
        ? document.createElement("img")
        : document.createElement("span")
      avatar.className = "w-5 h-5 rounded-full bg-purple-100 dark:bg-purple-500/20 flex items-center justify-center object-cover text-[8px] font-bold flex-shrink-0"
      if (member.dataset.avatarUrl) {
        avatar.src = member.dataset.avatarUrl
        avatar.alt = ""
      } else {
        avatar.textContent = (member.dataset.userName || "?").charAt(0).toUpperCase()
      }

      const name = document.createElement("span")
      name.textContent = member.dataset.userName

      const remove = document.createElement("button")
      remove.type = "button"
      remove.dataset.userId = member.dataset.userId
      remove.setAttribute("aria-label", `Remove ${member.dataset.userName}`)
      remove.className = "ml-0.5 w-4 h-4 rounded-full flex items-center justify-center hover:bg-purple-200 dark:hover:bg-purple-500/30"
      remove.textContent = "×"
      remove.addEventListener("click", (clickEvent) => this.removeSelection(clickEvent))

      chip.append(avatar, name, remove)
      this.selectedTarget.append(chip)
    })
  }
}
